module.exports = __webpack_public_path__ + "static/media/help.4457fe8f.webp";